import React, { useState } from "react"
import styled from "styled-components"
import Prompts from '../../lib/word-lists'

const MENU = [
  {
    name: "sketch",
    displayName: "Sketch",
    set: Prompts.NOUNS,
    content: value => <h4 key={value}>{value}</h4>,
  },
  {
    name: "mash",
    displayName: "Mashup-2",
    set: Prompts.NOUNS,
    quantity: 2,
    content: value => <div key={value}>{value} </div>,
  },
  {
    name: "journal",
    displayName: "Journal question",
    set: Prompts.QUESTIONS,
    content: value => <h4 key={value}>{value}</h4>,
  },
  {
    name: "bandnames",
    displayName: "Band poster",
    set: Prompts.BAND_NAMES,
    content: value => <h4 key={value}>{value}</h4>,
  },
  {
    name: "teamnames",
    displayName: "Team names",
    set: Prompts.TEAM_DOMAIN,
    quantity: 2,
    content: value => <div key={value}>{value} </div>,
  },
  {
    name: "font",
    displayName: "Font inspiration",
    set: Prompts.LETTERS,
    content: value => (
      <>
        <StyledImg key={value} src={`/lettering/${value}.jpg`} />
        <br />
        <small>
          <a href="https://www.artistsnetwork.com/art-techniques/easy-hand-lettering-techniques/">
            Artists network
          </a>
        </small>
      </>
    ),
  },
]

export default function DrawingPrompt() {
  const [activeButton, setActiveButton] = useState(null)
  const [content, setContent] = useState(null)

  const handleClick = e => {
    const name = e.target.name
    setActiveButton(name)
    serveContent(MENU.find(({name: setName}) => setName === name))
  }

  const serveContent = ({set, content, quantity}) => {
    const value = Array.from(Array(quantity)).map(() => {
      const randomIndex = Math.floor(Math.random() * Math.floor(set.length))
      return set[randomIndex]
    })
    const output = value.map(content)
    setContent(output)
  }

  return (
    <>
      <h3>Click for a prompt:</h3>
      <StyledGroup>
        {MENU.map(({ name, displayName }) => {
          if (name === activeButton) {
            return (
              <StyledActiveButton key={name} name={name} onClick={handleClick}>
                {displayName}
              </StyledActiveButton>
            )
          } else {
            return (
              <StyledButton key={name} name={name} onClick={handleClick}>
                {displayName}
              </StyledButton>
            )
          }
        })}
      </StyledGroup>
      <StyledContent>{content}</StyledContent>
    </>
  )
}

const StyledGroup = styled.div`
  display: flex;
`
const StyledButton = styled.button`
  opacity: 0.6;
  margin: 0.3rem;
  border: 5px solid transparent;
  border-radius: 50px;
`
const StyledActiveButton = styled(StyledButton)`
  opacity: 1;
  border-color: purple;
`
const StyledImg = styled.img`
  width: 50%;
`
const StyledContent = styled.div`
  min-height: 500px;
  text-align: center;
`
